import React from "react";
import "./App.css";
import store, { history } from "./state/store";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import theme from "./themes";
import "./fontawesome";
import PrivateRoute from "./components/containers/PrivateRoute/PrivateRoute";
import Base from "./components/containers/Base/Base";
import { LoginPage } from "./components/pages/LoginPage/LoginPage";
import RegisterCompanyPage from "./components/pages/RegisterCompanyPage/RegisterCompanyPage";
import LocationsPage from "./components/pages/LocationsPage/LocationsPage";
import OneLocationPage from "./components/pages/OneLocationPage/OneLocationPage";
import LessonsPage from "./components/pages/LessonsPage/LessonsPage";
import OneLessonPage from "./components/pages/OneLessonPage/OneLessonPage";
import HomePage from "./components/pages/HomePage/HomePage";
import SchedulePage from "./components/pages/SchedulePage/SchedulePage";
import BookingsPage from "./components/pages/BookingsPage/BookingsPage";
import PublishPage from "./components/pages/PublishPage/PublishPage";
import BlogsPage from "./components/pages/BlogsPage/BlogsPage";
import { OneBlogPage } from "./components/pages/OneBlogPage/OneBlogPage";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Base>
          <ConnectedRouter history={history}>
            <Switch>
              <Route path="/login" component={LoginPage} />
              <PrivateRoute
                path="/company"
                component={RegisterCompanyPage}
              ></PrivateRoute>
              <PrivateRoute exact path="/" component={HomePage}></PrivateRoute>
              <PrivateRoute
                path="/locations"
                component={LocationsPage}
              ></PrivateRoute>
              <PrivateRoute
                exact
                path="/schedule"
                component={SchedulePage}
              ></PrivateRoute>
              <PrivateRoute
                path="/schedule/show/:locationId/:lessonId"
                component={SchedulePage}
              ></PrivateRoute>
              <PrivateRoute
                exact
                path="/schedule/show"
                component={SchedulePage}
              ></PrivateRoute>
              <PrivateRoute
                path="/schedule/delete"
                component={SchedulePage}
              ></PrivateRoute>
              <PrivateRoute
                path="/schedule/create/:locationId/:lessonId"
                component={SchedulePage}
              ></PrivateRoute>
              <PrivateRoute
                path="/lessons"
                component={LessonsPage}
              ></PrivateRoute>
              <PrivateRoute
                path="/bookings"
                component={BookingsPage}
              ></PrivateRoute>
              <PrivateRoute
                path="/publish"
                component={PublishPage}
              ></PrivateRoute>
              <PrivateRoute
                path="/location/:id"
                component={OneLocationPage}
              ></PrivateRoute>
              <PrivateRoute
                path="/lesson/edit/:id"
                component={OneLessonPage}
              ></PrivateRoute>
              <PrivateRoute path="/posts" component={BlogsPage}></PrivateRoute>
              <PrivateRoute
                path="/post/edit/:id"
                component={OneBlogPage}
              ></PrivateRoute>
            </Switch>
          </ConnectedRouter>
        </Base>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
